import store from "@/store";

export const initVuex = () => {
    store.dispatch('user/INIT_USER').then(_ => {
    }).catch(_ => {
    })
}
